import axios from "axios";

const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL;

const auth = () => ({
  headers: {
    accessToken: localStorage.getItem("accessToken"),
  },
});

export const fetchTeams = async ({ instanceUniqueId, type, includeInactive = false } = {}) => {
  const response = await axios.get(`${BASE_URL}/teams`, {
    ...auth(),
    params: {
      ...(instanceUniqueId ? { instanceUniqueId } : {}),
      ...(type ? { type } : {}),
      ...(includeInactive ? { includeInactive: true } : {}),
    },
  });
  return response.data;
};

export const fetchTeam = async (teamId, { instanceUniqueId } = {}) => {
  const response = await axios.get(`${BASE_URL}/teams/${teamId}`, {
    ...auth(),
    params: {
      ...(instanceUniqueId ? { instanceUniqueId } : {}),
    },
  });
  return response.data;
};

export const createTeam = async (payload) => {
  const response = await axios.post(`${BASE_URL}/teams`, payload, auth());
  return response.data;
};

export const updateTeam = async (teamId, payload) => {
  const response = await axios.put(`${BASE_URL}/teams/${teamId}`, payload, auth());
  return response.data;
};

export const deactivateTeam = async (teamId, instanceUniqueId) => {
  const response = await axios.delete(`${BASE_URL}/teams/${teamId}`, {
    ...auth(),
    params: {
      ...(instanceUniqueId ? { instanceUniqueId } : {}),
    },
  });
  return response.data;
};

export const addTeamMembers = async (teamId, userIds, instanceUniqueId) => {
  const response = await axios.post(
    `${BASE_URL}/teams/${teamId}/members`,
    {
      instanceUniqueId,
      userIds,
    },
    auth()
  );
  return response.data;
};

export const removeTeamMember = async (teamId, userId, instanceUniqueId) => {
  const response = await axios.delete(`${BASE_URL}/teams/${teamId}/members/${userId}`, {
    ...auth(),
    params: {
      ...(instanceUniqueId ? { instanceUniqueId } : {}),
    },
  });
  return response.data;
};

export const fetchTeamReportMembers = async (teamId, instanceUniqueId) => {
  const response = await axios.get(`${BASE_URL}/teams/${teamId}/report-members`, {
    ...auth(),
    params: {
      ...(instanceUniqueId ? { instanceUniqueId } : {}),
    },
  });
  return response.data;
};
